import { Injectable } from '@angular/core';
import * as moment from 'moment';
import constantURL from '../../../../shared/constantURL';
import { BaseLoggedInPostService } from '../../../../shared/services/base-logged-in-post.service';

@Injectable({
  providedIn: 'root'
})
export class FetchPromocodeService extends BaseLoggedInPostService {
  _path = constantURL.promocode.fetchPromocodes;

  processResult(res: any) {
    const r = res.result.map((object: any) => {
      object.createdAt = moment(object.createdAt).format('LL');
      object.expiry = moment(object.expiry).format('LL');
      return object;
    });
    return res;
  }
}
